import { getWordpressPostList } from "@src/functions/wordpress";
import WordpressPostList from "../common/components/WordpressPostList";

export async function getServerSideProps() {
  const postJson = await getWordpressPostList("1389");
  return {
    props: { data: postJson },
  }
}

function Recycling ({ data }: any) {
  return (
    <WordpressPostList
      group="recycling"
      titleName="How to Recycle"
      listTitle="How to Recycle"
      data={data}
    />
  );
};

export default Recycling;